<script>
    // export let selectedValue = null;
    // export let selectedId = null;

    export let settings = {};
    export let options = [];
    export let style;
    export let value;
    export let className;
    export let callback;
    export let emptyOptionName;
    export let element;
</script>

<select
    bind:value
    bind:this={element}
    on:change={() => {
        if (callback) callback();
    }}
    class={className}
    disabled={settings.isDisabled}
    {style}
>
    {#if options.length > 0}
        <option value={null} selected={value == null}>
            {emptyOptionName || "-"}
        </option>

        {#each options as option}
            <option
                value={option[settings?.valueKey]}
                selected={option[settings?.valueKey] == value ? "selected" : ""}
            >
                {settings?.nameKey ? option[settings?.nameKey] : option.name}
            </option>
        {/each}
    {/if}
</select>

<style>
    .black {
        background: rgb(69, 69, 69);
        color: white;
    }

    .gray {
        background: #ddd;
    }

    .green {
        background: rgb(76, 182, 60);
        color: white;
    }

    .blue {
        background: rgb(60, 105, 182);
        color: white;
    }

    .red {
        background: rgb(231, 65, 65);
        color: white;
    }
</style>
